import { DateRange, GroupedByDate } from '../types';

export const isDateRangeEmpty = (range: DateRange): boolean => (
  range[0] === null || range[1] === null
);

export const findNearestElements = <T extends { code: string }>(
  groups: GroupedByDate<T>,
  code: string
): [null | string, null | string] => {
  const combined = [
    ...groups.today,
    ...groups.yesterday,
    ...groups.thisWeek,
    ...groups.lastWeek,
    ...groups.thisMonth,
    ...groups.lastMonth,
    ...groups.lastThreeMonths,
    ...groups.lastSixMonths
  ];
  const index = combined.findIndex(s => s.code === code);

  if (index === -1) {
    return [null, null];
  }

  const prev = combined[index - 1];
  const next = combined[index + 1];

  return [prev?.code ?? null, next?.code ?? null];
};

export const findElementInGroups = <T extends { code: string }>(
  groups: GroupedByDate<T>,
  code: string
): T | null => {
  const combined = [
    ...groups.today,
    ...groups.yesterday,
    ...groups.thisWeek,
    ...groups.lastWeek,
    ...groups.thisMonth,
    ...groups.lastMonth,
    ...groups.lastThreeMonths,
    ...groups.lastSixMonths
  ];

  return combined.find(v => v.code === code) ?? null;
};

export const getTotalCountInGroups = <T extends { code: string }>(
  groups: GroupedByDate<T>
): number => {
  const combined = [
    ...groups.today,
    ...groups.yesterday,
    ...groups.thisWeek,
    ...groups.lastWeek,
    ...groups.thisMonth,
    ...groups.lastMonth,
    ...groups.lastThreeMonths,
    ...groups.lastSixMonths
  ];

  return combined.length;
};
